module.exports = __webpack_public_path__ + "assets/img/list-logo-en.5f80dbde.png";